import { HashRouter as Router } from 'react-router-dom';
import AppHeader from './Components/Header';
import MainContainer from './Components/MainContainer';

function App() {
    return (
        <Router>
            <div className="col app">
                <AppHeader />
                <MainContainer />
            </div>
        </Router>
    );
}

export default App;
